import { Component, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { NavigationEnd, Router, UrlTree } from '@angular/router';
import { ResourceService } from 'src/app/services/common/resource.service';
import { StorageService } from 'src/app/services/common/storage.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { UserService } from 'src/app/services/user.service';
import { Subscription, timer, of } from 'rxjs';
import { catchError, filter, switchMap, tap } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { ThemeService, Theme } from 'src/app/services/theme.service'; 


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  
footerBannerStyle: string | null = null;

  footerBackgroundColor = 'white';
  private subs = new Subscription();
  @Output() themeChanged = new EventEmitter<Theme>();

  isLoggedIn: any = false;
  showInstallBox = false;
  resource: any = {};
  showLoginElement: any = true;

  bannerImages: string[] = [];
  currentBanner: string | null = null;
  private bannerIdx = 0;
  private rotatorSub?: Subscription;
  private routeSub?: Subscription;
  private readonly rotateMs = 4000; 

  constructor(
    private userInfoService: UserInfoService,
    private storageService: StorageService,
    private router: Router,
    private resourceService: ResourceService,
    private userService: UserService,
    private http: HttpClient,
    private themeService: ThemeService
  ) {
    window.addEventListener('beforeinstallprompt', () =>
      setTimeout(() => {
        this.showInstallBox = !!(window as any).beforeInstallPrompt;
      }, 0)
    );
  }

  ngOnInit(): void {
    this.loadResoruce();

    this.resourceService.languageSubject.subscribe(res => this.resource = res);

    this.isLoggedIn = this.userInfoService.getLoginFlag();
    this.storageService.loginSubject.subscribe(() => {
      this.isLoggedIn = this.userInfoService.getLoginFlag();
    });

        this.subs.add(
      this.themeService.theme$.subscribe(t => {
        this.footerBackgroundColor = (t === 'light') ? 'white' : 'black';
      })
    );

    this.routeSub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        this.showLoginElement = !(/login|register/.test(this.router.url));
        this.loadFooterBannersForCurrentOrg();
      });

    this.loadFooterBannersForCurrentOrg();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.stopRotation();
    this.routeSub?.unsubscribe();
  }

  loadResoruce() {
    this.resourceService.loadResoruce().subscribe(response => {
      this.resource = response;
    });
  }

  singleFooterWidget = [
    { logo: `assets/img/logo.png`, paragraph: `Launching and redeeming coupons made easier!` }
  ];

  marxaYear: number = new Date().getFullYear();

  onClickInstall() {
    (window as any).triggerInstallPopup();
  }

  private getOrganizationIdFromUrl(): string | null {
    const tree: UrlTree = this.router.parseUrl(this.router.url);
    return tree.queryParams?.['organizationId'] || null;
  }

  private stopRotation() {
    this.rotatorSub?.unsubscribe();
    this.rotatorSub = undefined;
  }

  private startRotation() {
    this.stopRotation();
    if (!this.bannerImages.length) {
      this.currentBanner = null;
      return;
    }
    if (this.bannerImages.length === 1) {
      this.currentBanner = this.bannerImages[0];
this.footerBannerStyle = this.currentBanner ? `url('${this.currentBanner}')` : null;

      return;
    }

this.bannerIdx = 0;
this.currentBanner = this.bannerImages[0];
this.footerBannerStyle = this.currentBanner ? `url('${this.currentBanner}')` : null;

this.rotatorSub = timer(this.rotateMs, this.rotateMs).subscribe(() => {
  this.bannerIdx = (this.bannerIdx + 1) % this.bannerImages.length;
  this.currentBanner = this.bannerImages[this.bannerIdx];
  this.footerBannerStyle = this.currentBanner ? `url('${this.currentBanner}')` : null;
});
  }

  private mapBannersPayload(res: any): string[] {
    console.log("res", res)
    const root = res?.data ?? res;
    const list = root?.bannerImages ?? root?.images ?? root ?? [];
    return (Array.isArray(list) ? list : [])
      .map((x: any) => typeof x === 'string' ? x : (x?.src || x?.url || x?.imageUrl || x?.path || ''))
      .filter(Boolean);
  }

private loadFooterBannersForCurrentOrg(): void {
  const orgId = this.getOrganizationIdFromUrl();
  if (!orgId) {
    this.bannerImages = [];
    this.currentBanner = null;
    this.stopRotation();
    return;
  }

 
this.userService.getUser(orgId).pipe(
  catchError(() => of(null)),
  switchMap(user => {
    console.log('user', user);
    const isOn = !!user?.data?.isBannerActive;

    if (!isOn) {
      this.bannerImages = [];
      this.currentBanner = null;
      this.footerBannerStyle = null;
      this.stopRotation();
      return of(null);
    }

    return this.userService.getBanners().pipe(
      catchError(err => {
        console.error('Failed to load banners', err);
        this.bannerImages = [];
        this.currentBanner = null;
        this.stopRotation();
        return of(null);
      }),

tap(response => {
  console.log('banners response', response);

  const urls = this.mapBannersPayload(response);
  console.log('mapped banner urls', urls);

  this.bannerImages = Array.isArray(urls) ? urls : [];

  if (this.bannerImages.length > 0) {
    this.startRotation();
  } else {
    this.bannerImages = [];
    this.currentBanner = null;
    this.footerBannerStyle = null;
    this.stopRotation();
  }
})

    );
  })
).subscribe();

}

 toggleFooterBg() {
       this.themeService.toggleTheme();
    this.themeChanged.emit(this.themeService.current);

  }
  
}
